import { Component } from 'utils';
import { projectsActions } from '../../../../store/reducers/projectsReducer';
import { projectActions } from "../../../../store/reducers/projectReducer";
import {licenseActions } from '@src/store/reducers/licenseReducer';


@Component({
    controllerAs: 'vm',
    template: require('./project-context.tpl.html'),
    bindings: {
        projectId: '@',
        isDraft: "<",
        project: "<"
    }
})
export class ProjectContextComponent {
    static $inject = ['store', '$state', 'dialogManagerService', 'sessionService', 'packagesLocalHistoryService', 'projectsLocalHistoryService', 'utils', '$scope','openProject'];

    constructor(store, $state, dialogManagerService, sessionService, packagesLocalHistoryService, projectsLocalHistoryService, utils, $scope, openProject) {
        this.store = store;
        this.$state = $state;
        this.dialogManagerService = dialogManagerService
        this.sessionService = sessionService;
        this.packagesLocalHistoryService = packagesLocalHistoryService;
        this.projectsLocalHistoryService = projectsLocalHistoryService;
        this.utils = utils;
        this.$scope = $scope;

        this.$scope.$on(openProject, (id,linkId) => {
            this.goToProject(id,linkId);
        });

        Object.defineProperty(this, 'Actions', {
            value: Object.freeze({ Open: "Open", Delete: "Delete", Edit: "Edit" }),
            writable: false,
            enumerable: true,
            configurable: false
        });
    };

    deleteProject() {
        const onConfirm = () => {
            if (this.isDraft) 
            {
                this.store.dispatch({ type: projectsActions.DELETE_DRAFT, payload: { id: this.projectId } });
            } 
            else 
            {
                this.store.dispatch({ type: projectsActions.DELETE_PROJECT, payload: { id: this.projectId } }).then(() => {
                    this.store.dispatch({ type: licenseActions.GET_LICENSE_WARNINGS });
                });
                this.packagesLocalHistoryService.removePackageSelectionHistory(this.$state.$current.locals.globals.userDetails.data.id, this.projectId);
                this.projectsLocalHistoryService.DeleteProjectHistory(this.$state.$current.locals.globals.userDetails.data.id, this.projectId);
            }
            this.store.dispatch({ type: projectActions.SAVE_PROJECT_BEFORE_EDIT, payload: {} });
        };
        const dialogData = { title: 'Delete Project', action: 'delete', objectType: 'project', item: this.project.name };
        this.dialogManagerService.showConfirmationDialog(dialogData, onConfirm);
        
    };

    goToProject(id, projId) {
        if (projId && projId !== Number(this.projectId)) {
            return;
        }
        if (this.isDraft) {
            this.store.dispatch({ type: projectActions.GET_EDIT_PROJECT, payload: { projectId: this.projectId },
                callback: (response) => {
                    this.store.dispatch({
                        type: projectActions.SET_EDIT_MODE,
                        payload: {
                            editMode: true,
                            isNew: (!response.data.parentId) ? true : false,
                            isNewDraft: response.data.isNew
                        }
                    });
                    this.sessionService.set(`project_${response.data.id}`, this.project.name + ' (Draft)');
                    this.$state.go('app.authorized.environments', { id: response.data.id, name: this.project.name + ' (Draft)', fromContext: true })
                }
            });
        } else {
            this.store.dispatch({ type: projectActions.SET_EDIT_MODE, payload: { editMode: false } });
            this.sessionService.set(`project_${this.projectId}`, this.project.name);
            this.$state.go('app.authorized.environments', { id: this.projectId, name: this.project.name })
        }
    }

    editProject() {
        this.store.dispatch({
            type: projectActions.GET_EDIT_PROJECT,
            payload: { projectId: this.projectId },
            callback: (response) => {
                this.store.dispatch({
                    type: projectActions.SET_EDIT_MODE,
                    payload: { editMode: true, isNewDraft: response.data.isNew }
                });
                this.sessionService.set(`project_${response.data.id}`, response.data.name + ' (Draft)');
                this.$state.go('app.authorized.environments', { id: response.data.id, name: response.data.name + ' (Draft)', fromContext: true })
            }
        });
    }

    getActions = () => {
        return [
            { Title: this.Actions.Open, Key: this.Actions.Open },
            { Title: this.Actions.Edit, Key: this.Actions.Edit },
            { Title: this.Actions.Delete, Key: this.Actions.Delete }
        ];
    }

    clickAction = (action) => {
        switch (action.Key) {
            case this.Actions.Open:
                this.goToProject();
                break;
            case this.Actions.Edit:
                this.editProject();
                break;
            case this.Actions.Delete:
                this.deleteProject();
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/authorized/projects/project-context/project-context.js